import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  organizationsForEdit: {
    id: undefined,
    name: "",
    leagalName: "",
    sellerFee: 0,
    offerThreshold: 0,
  },
  message: null,
  messageType: null,
  showMessage: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const organizationsSlice = createSlice({
  name: "organizations",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // organizations loader
    organizationsListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    organizationsList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadOrganizationsForEdit: (state, action) => {
      state.organizationsForEdit = action.payload;
    },
    loadOrganizationsMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
  },
});
